import { Modal } from 'antd'
import Router from 'next/router'

export const useValidateVip = () => {
  const vipModal = (content?: string) => {
    Modal.confirm({
      title: '提示',
      maskStyle: {
        backgroundColor: 'rgba(0,0,0,0.8)',
      },
      width: 270,
      className: `hookModal dark`,
      content: (
        <div className="text-neutral-400 text-sm text-center">
          {content || '此模型仅限VIP会员专享使用'}
        </div>
      ),
      okText: '前往开通',
      onOk: close => {
        Router.push('/member')
        close()
      },
    })
  }
  return {
    /** 非会员提示弹窗 */
    vipModal,
  }
}
